import { BaoRig } from "../../game/bao/BaoRig";
import { CAST, CHARACTERS } from "../../game/bao/characters";
import { NEUTRAL } from "../../game/bao/rig";

export const CastPicker = ({ value, onChange }) => (
  <section data-testid="cast-picker" aria-label="Personnages" className="shadow-soft rounded-[2rem] border border-border/70 bg-card p-4 sm:p-6">
    <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-primary-strong">La distribution · même squelette, même exigence</p>
    <div className="-mx-1 mt-3 flex snap-x gap-3 overflow-x-auto px-1 pb-1" role="radiogroup">
      {CAST.map((k) => {
        const c = CHARACTERS[k], on = value === k;
        return (
          <button key={k} role="radio" aria-checked={on} data-testid={`cast-${k}`} onClick={() => onChange(k)}
            className={`group relative w-[150px] shrink-0 snap-start overflow-hidden rounded-3xl border-2 text-left transition-[transform,border-color] duration-300 hover:-translate-y-0.5 ${on ? "border-[#17A2A2]" : "border-transparent"}`}>
            <div className="relative h-[150px] bg-gradient-to-b from-[#F6E9CF] to-[#EAF7F5] dark:from-[#13324F] dark:to-[#0A2540]">
              <img decoding="async" src={c.sheet} alt="" className="absolute inset-0 h-full w-full object-cover object-left opacity-90 transition-opacity duration-300 group-hover:opacity-100" loading="lazy" />
              <div className="absolute bottom-0 right-0 w-[64px] rounded-tl-2xl bg-white/80 backdrop-blur dark:bg-[#0A2540]/80"><BaoRig pose={NEUTRAL} view="front" width="100%" character={k} shadow={false} /></div>
            </div>
            <div className={`px-3 py-2 ${on ? "bg-[#0A2540] text-white" : "bg-muted"}`}>
              <p className="font-display text-base font-semibold leading-tight">{c.name}</p>
              <p className={`text-[11px] leading-tight ${on ? "text-[#4FD1C5]" : "text-muted-foreground"}`}>{c.role}</p>
            </div>
          </button>
        );
      })}
    </div>
    <p className="mt-2 text-xs text-muted-foreground" data-testid="cast-blurb">{CHARACTERS[value].blurb}</p>
  </section>
);
